<template>
  <div
    class="icon-notification text-right pointer-events-none"
    style="width:2rem;height:2rem;"
    :style="{
      left: left,
      right: right,
      top: top,
      transform: transform
    }"
  >
    <img
      src="@/assets/icons/genicon-icons8-alert.svg"
      class="w-full h-full"
      alt="ⓘ"
    />
  </div>
</template>

<script>
export default {
  name: "IconNotification",
  props: ["left", "top", "right", "transform"]
};
</script>

<style lang="scss" scoped>
.icon-notification {
  display: inline-block;
  position: absolute;
}
.icon-notification > img {
  animation: breathe 2s ease-in-out infinite;
}
@keyframes breathe {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>
